<blaze-dialog (closeDialog)="closeDialog()" [showFooter]="false" class="column-use-dialog">
  <div icon class="header-icon">
    <mat-icon class="icon-16" svgIcon="icon_search_16" />
  </div>

  <div title data-cy="ColumnUseDialog:title">Column Use</div>

  <div content class="column-use-dialog__content">
    <p class="column-use-dialog__description">
      @if (references.length) {
        This column is used in the following components or workflows:
      } @else {
        This column is not used in any components or workflows.
      }
    </p>

    <blaze-workflow-references-list
      [references]="references"
      (referenceSelected)="openReference($event)"
    />
  </div>
</blaze-dialog>
